import { getFrameLabel } from '@Constants/getFrameLabel';
import { type ApiRentVariant } from '@Model';
import { EditFrameMode, EditFrameShell, type IEditFrame, useGuiBinder } from '@synqo/frontend-component-library';
import { RentVariantConditionsSection, RentVariantMainSection } from './Sections';

// @ai-generated 2026-10-21T09:12:12+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

interface IProps {
    frame: IEditFrame<ApiRentVariant>;
}

export function RentVariantFrameBody({ frame }: IProps) {
    const rentVariant = frame.data;

    const binder = useGuiBinder<ApiRentVariant>({
        data: rentVariant,
        meta: frame.meta,
        canEdit: frame.mode !== EditFrameMode.View,
        requestUpdateState: frame.requestUpdateState,
    });

    return (
        <EditFrameShell
            frame={frame}
            headerProps={{
                label: getFrameLabel('Miet-Variante', frame.mode),
                resourceLabel: 'Miet-Variante',
                ...frame.events,
            }}
            bannerProps={{
                mode: frame.mode,
                loading: frame.pendingAction !== undefined,
                ...frame.events,
            }}
        >
            <RentVariantMainSection binder={binder} />

            <RentVariantConditionsSection binder={binder} />
        </EditFrameShell>
    );
}
